// extracted by mini-css-extract-plugin
export var heroImage = "heroImage-module--heroImage--06714";
export var marginTop = "heroImage-module--marginTop--d0173";
export var mobileMarginTop = "heroImage-module--mobileMarginTop--d2a3a";